import { memo, useCallback } from "react";
import PropTypes from "prop-types";
import "./BackButton.scss";
import { FormattedMessage } from "react-intl";
import IconBack from "app/pages/.shared/static/icons/IconBack";
import { sendTagOnBackButton } from "app/utils/analytics";
import { useLocation, useNavigate } from "react-router-dom";
import Button, { BUTTON_SIZES, BUTTON_VARIANTS } from "app/pages/.shared/form/Button";

const BackButtonComponent = ({ to, label, forceBrowserBack, onClick }) => {
	const { pathname } = useLocation();
	const navigate = useNavigate();

	const handleClick = useCallback(() => {
		sendTagOnBackButton(pathname);
		onClick();
	}, [pathname, onClick]);

	const backHistory = useCallback(() => {
		if (typeof window !== "undefined") {
			onClick();
			navigate(-1);
		}
	}, [onClick, navigate]);

	if (forceBrowserBack) {
		return (
			<Button
				variant={BUTTON_VARIANTS.BORDERLESS}
				size={BUTTON_SIZES.LARGE}
				className="back-button"
				onClick={backHistory}
				data-testid="back-button"
				icon={<IconBack />}
				label={
					<div className="back-button__label">
						{label && <FormattedMessage id={label} />}
					</div>
				}
			/>
		);
	}

	return (
		<div className="back-button">
			<Button
				variant={BUTTON_VARIANTS.BORDERLESS}
				size={BUTTON_SIZES.LARGE}
				to={{ ...to }}
				replace
				onClick={handleClick}
				data-testid="back-button"
				icon={<IconBack />}
				label={
					<div className="back-button__label">
						{label && <FormattedMessage id={label} />}
					</div>
				}
			/>
		</div>
	);
};

BackButtonComponent.propTypes = {
	to: PropTypes.object,
	onClick: PropTypes.func,
	label: PropTypes.string,
	forceBrowserBack: PropTypes.bool,
};

BackButtonComponent.defaultProps = {
	onClick: () => {},
	to: {},
};

export const BackButton = memo(BackButtonComponent);
